{
  "api_docs": "Documentation API",
  "search": "Recherche",
  "accept": "Accepter",
  "create": "Créer",
  "submit": "Envoyer",
  "delete": "Supprimer",
  "cancel": "Annuler",
  "enable": "Activer",
  "deploy": "Déployer",
  "scan": "Scanner",
  "download": "Télécharger",
  "enabled": "Activé",
  "disable": "Désactiver",
  "disabled": "Désactivé",
  "export": "Exporter",
  "open_modal": "Ouvrir la modalité",
  "uuid": "UUID",
  "no_items": "Aucun élément",
  "not_applicable": "N/A",
  "requires_permission": "Vous avez besoin de la permission {permission} . | Vous avez besoin des autorisations suivantes : {permission}",
  "copied_to_clipboard": "Copié dans le presse-papiers !",
  "click_to_reveal": "Cliquer pour afficher.",
  "reset_password": "Réinitialiser le mot de passe",
  "unknown": "Inconnu",
  "no_results_found": "Aucun résultat trouvé",
  "results": "aucun résultat | Un résultat | {n} résultats",
  "more_info": "Plus d'informations",
  "changes": "Changements",
  "metadata": "Métadonnées",
  "install": "Installer",
  "manage": "Gérer",
  "edit": "Éditer",
  "trigger": "Déclencher",
  "never": "Jamais",
  "none": "Aucun",
  "save": "Sauvegarder",
  "import": "Importer",
  "success": "Succès",
  "info": "Information",
  "warning": "Avertissement",
  "danger": "Danger",
  "reset": "Réinitialiser",
  "loading": "Chargement",
  "click_to_upload_image": "Cliquer pour envoyer une nouvelle l'image",
  "invalid_file_type": "Type de fichier invalide",
  "information": "Informations",
  "description": "Description",
  "at_a_glance": "En bref",
  "settings": "Réglages",
  "limits": "Limites",
  "admin_area": "Espace d'administration",
  "announcements": "Annonces",
  "notifications": "Notifications",
  "clear_all": "Effacer tout",
  "formats": "Format :",
  "device_information": "Information de l’appareil",
  "permissions": "Permissions",
  "lock": "Verouiller",
  "unlock": "Dévérouiller",
  "toggle": "Activer/désactiver",
  "reinstall": "Réinstaller",
  "suspend": "Suspendre",
  "unsuspend": "Retirer la suspension",
  "here": "ici",
  "users": "Utilisateurs",
  "allocations": "Allocations",
  "database_hosts": "Hôte de la base de données",
  "server_databases": "Bases de données du serveur",
  "locations": "Emplacements",
  "nests": "Nests",
  "eggs": "Eggs",
  "nodes": "Nœuds",
  "servers": "Serveurs",
  "admin": "Admin",
  "support_op": "Support",
  "something_went_wrong": "Une erreur est survenue avec cette action.",
  "daemon_connection_exception": "Il y a eu une exception lors de la tentative de communication avec le démon.",
  "server": {
    "no_servers": "Aucun serveur",
    "no_servers_description": "On dirait que vous n'avez aucun serveur...",
    "no_servers_description_admin": "Il semble que vous n'ayez pas de serveurs. Vous pouvez créer des serveurs à partir de la zone d'administration en cliquant sur {link}.",
    "hostname": "Nom du serveur",
    "name": "Nom",
    "cpu": "CPU",
    "memory": "Mémoire",
    "swap": "Swap",
    "disk": "Disque",
    "node": "Nœud",
    "players": "Joueurs",
    "players_amount": "{current} / {max} Joueurs",
    "ip": "IP",
    "manage": "Gérer",
    "go_to_console": "Accéder à la console",
    "launch_sftp": "Lancer SFTP",
    "on_node": " sur le noeud : {node}",
    "gamemode": "Mode de jeu",
    "version": "Version",
    "map": "Carte",
    "resource_usage": "Utilisation des ressources",
    "memory_usage": "Utilisation de la mémoire",
    "cpu_usage": "Utilisation CPU",
    "status": {
      "unknown": "Inconnu",
      "error": "Erreur",
      "offline": "Hors ligne",
      "online": "En ligne",
      "starting": "Démarrage",
      "stopping": "Arrêt en cours",
      "migrating": "Migration en attente",
      "installing": "Installation",
      "failed_install": "L'installation a échoué",
      "suspended": "Suspendu",
      "updating": "Mise à jour",
      "moving": "Déplacement",
      "creating_backup": "Création d'une sauvegarde",
      "deploying_backup": "Déploiement de la sauvegarde"
    }
  },
  "release_types": {
    "alpha": "Alpha",
    "beta": "Bêta",
    "release": "Release"
  },
  "units": {
    "bytes": "B",
    "kilobytes": "KB",
    "megabytes": "MB",
    "gigabytes": "GB",
    "terabytes": "TB"
  },
  "dates": {
    "minute_abbreviation": "m",
    "minute": "minute | minutes"
  },
  "labels": {
    "unknown": "Inconnu",
    "latest": "Derniers",
    "recommended": "Recommandé"
  },
  "languages": {
    "en": "Anglais",
    "ar_SA": "Arabe",
    "cs_CZ": "Tchèque",
    "da_DK": "Danois",
    "de_DE": "Allemand",
    "en_PT": "Anglais (pirate)",
    "es_AR": "Espagnol (Argentine)",
    "es_EM": "Espagnol (Moderne)",
    "et_EE": "Estonien",
    "fi_FI": "Finlandais",
    "fr_FR": "Français",
    "hi_IN": "Hindi",
    "hr_HR": "Hongrois",
    "it_IT": "Italien",
    "ja_JP": "Japonais",
    "nl_NL": "Néerlandais",
    "no_NO": "Norvégien",
    "pl_PL": "Polonais",
    "pt_BR": "Portugais",
    "ro_RO": "Roumain",
    "ru_RU": "Russe",
    "ru_UA": "Ukrainien",
    "sv_SE": "Suédois",
    "tr_TR": "Turque",
    "ur_PK": "Urdu",
    "zh_CN": "Chinois (simplifié)"
  }
}
